<nz-form-item class="ui-form-file">
  <nz-form-label *ngIf="!hideLabel" [nzRequired]="isRequired">{{
    label | localization
  }}</nz-form-label>
  <nz-form-control
    [nzValidateStatus]="control ?? 'success'"
    [nzErrorTip]="errorTip | localization"
  >
    <button
      class="ui-form-file-input-wrapper"
      [ngClass]="{ hasFile: value }"
      (click)="onFileInputClicked()"
      [disabled]="disabled"
    >
      <input
        #formFileInput
        type="file"
        (change)="onFileSelected($event)"
        class="ui-form-file-input"
      />
      <ng-container *ngIf="!value; else selectedFileViewer">
        <ui-icon
          class="file-upload-icon mr-8px"
          name="file-add"
          size="15px"
        ></ui-icon>
        <span>{{ 'FORM_CHOOSE_FILE_PLACEHOLDER' | localization }}</span>
      </ng-container>

      <ng-template #selectedFileViewer>
        <ui-icon
          class="file-upload-icon mr-8px"
          name="file"
          size="15px"
        ></ui-icon>
        <span class="file-name">{{ fileName }}</span>
        @if(!disabled){
        <ui-icon
          class="file-upload-icon download-file-icon mr-8px"
          [name]="isFileDownloading ? 'loading' : 'download'"
          size="16px"
          [isSpining]="isFileDownloading"
          [clickable]="true"
          (clicked)="onDownload($event)"
        ></ui-icon>
        <ui-icon
          class="file-upload-icon remove-file-icon"
          name="delete"
          size="16px"
          [clickable]="true"
          (clicked)="onRemoveFile($event)"
        ></ui-icon>
        }
      </ng-template>
    </button>
  </nz-form-control>
</nz-form-item>
